import { render, staticRenderFns } from "./CorrectionDlg.vue?vue&type=template&id=76105d30&scoped=true&"
import script from "./CorrectionDlg.vue?vue&type=script&lang=js&"
export * from "./CorrectionDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76105d30",
  null
  
)

export default component.exports